import { Component, inject, signal } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ReconciliationMultipleBarchart } from '../../chart/reconciliation-multiple-barchart/reconciliation-multiple-barchart.component';
import { ChartData, GroupedBarChartComponent } from '../../../../_shared';
import { TranslocoDirective } from '@jsverse/transloco';


@Component({
  selector: 'app-reconciliation-variate-breakdown',
  standalone: true,
  imports: [GroupedBarChartComponent, TranslocoDirective],  // DoubleBarchart
  templateUrl: './reconciliation-variate-breakdown.component.html',
  styleUrl: './reconciliation-variate-breakdown.component.scss',
})
export class ReconciliationVariateBreakdown {
  public fullChart = signal<boolean>(false);
  private readonly modalRef = inject(NgbActiveModal);
  private readonly modalService = inject(NgbModal);

  protected reconciliationVariateData = ChartData.reconciliationVariate;

  protected closeModal(): void {
    this.modalRef.close();
  }

  protected fullChartClick(): void {
    // this.dialog.open(ReconciliationMultipleBarchart, {
    //   panelClass: ['fuelGraphModal'],
    // });

    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    };
    const modalRef = this.modalService.open(ReconciliationMultipleBarchart, modalOptions);
  }
}
